<app-header *ngIf="standalone"></app-header>
<router-outlet></router-outlet>
<app-ts-logo></app-ts-logo>